/* @flow */

export const WIDTH = 2592;
export const HEIGHT = 1632;

export const CUSTOMER_WIDTH = 360;
export const SUSHI_HEIGHT = 168;

export const MIN_WIDTH = CUSTOMER_WIDTH * 3;
export const MIN_HEIGHT = HEIGHT;

export const DISH_GAP = 15;

export const SUSHI_ICON_BORDER = 8;
export const SUSHI_ICON_SIZE = HEIGHT * 0.07 + 2 * SUSHI_ICON_BORDER;
export const SUSHI_ICON_MARGIN = (CUSTOMER_WIDTH * 3 - SUSHI_ICON_SIZE * 8) / 7 / 2;
